import {
  RAFFLE_MY_TICKETS_TABS,
  GET_RAFFLE_MY_TICKET_LIST_REQUEST,
  GET_RAFFLE_MY_TICKET_LIST_SUCCESS,
  GET_RAFFLE_MY_TICKET_LIST_FAILURE,
  GET_RAFFLE_MY_TICKET_LIST_RESET
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import axios from 'axios';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

const raffleTabEnums = [
  { tabCode: 'ASSIGNED', tabName: 'Devam Eden', url: 'devam-eden' },
  { tabCode: 'WON', tabName: 'Kazanan', url: 'kazanan' },
  { tabCode: 'LOST', tabName: 'Kaybeden', url: 'kaybeden' }
];

export const getRaffleMyTicketsTabs = () => async (dispatch, getState) => {
  const myTicketsTabs = {
    status: { code: 200, message: 'Success' },
    tabs: raffleTabEnums
  };

  dispatch({
    type: RAFFLE_MY_TICKETS_TABS,
    payload: myTicketsTabs
  });
};

export const getRaffleMyTicketList = tabName => async (dispatch, getState) => {
  let pagination = getState().raffle.raffleMyTickets.ticketList.pagination;
  let { start, end, pageSize } = pagination;

  try {
    dispatch({
      type: GET_RAFFLE_MY_TICKET_LIST_REQUEST
    });

    const activeTab = raffleTabEnums.find(tab => tab.url === tabName && tab.tabCode);

    if (activeTab) {
      const res = await axios({
        method: 'get',
        url: `${API_GATEWAY}/mobile/raffle/ticket/assigned`,
        params: {
          start,
          end,
          status: activeTab.tabCode
        }
      });

      if (res.data.status.code !== 200 || (res.data.tickets && res.data.tickets.length < 1)) {
        throw res;
      }

      pagination = {
        ...pagination,
        start: start + pageSize,
        end: end + pageSize,
        hasMore: true
      };
  
      dispatch({
        type: GET_RAFFLE_MY_TICKET_LIST_SUCCESS,
        payload: res.data,
        pagination: pagination
      });
    }

  } catch (e) {
    dispatch({
      type: GET_RAFFLE_MY_TICKET_LIST_FAILURE,
      payload: e && e.data || errorMessage
    });
  }
};

export const resetRaffleMyTicketList = () => ({
  type: GET_RAFFLE_MY_TICKET_LIST_RESET
});
